import { IconAlertTriangle } from '@tabler/icons-react';
import type React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';

const CODE_RENAME_WARNING =
  "Renaming this format's code will break anything that looks it up by code, including: payment processors, file generators, reconciliation + return pipelines, and seeds that resolve file_format_id by code (e.g. resolveFileFormatIdByCode in provider seeds). Make sure to update any affected runtime constants (file-processors/constants.ts, file-processors/registry.ts) and coordinate with downstream services before saving.";

interface FileFormatCodeWarningProps {
  visible: boolean;
}

export const FileFormatCodeWarning: React.FC<FileFormatCodeWarningProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <Alert variant="default" className="border-amber-200 bg-amber-50 text-amber-950">
      <IconAlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertDescription className="text-sm">{CODE_RENAME_WARNING}</AlertDescription>
    </Alert>
  );
};
